/**
 * migracion_bid_frontend/src/components/misc/spin.js
 *
 * Spin component for loading using AntDesign's spin.
 */

import { Space, Spin } from "antd";
import React from "react";

export default function CenterSpin() {
  return (
    <Space
      size="middle"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          height: "150px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Spin size={"large"} />
      </div>
    </Space>
  );
}
